/**
* User management & login
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('member.membership', {
            url: '/' + urls.member.membership.fr, // TODO : when multilang, change this to something dynamic
            abstract: true,
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                content: {
                    controller: ['$scope', '$rootScope', '$filter', function ($scope, $rootScope, $filter) {
                        // remove warning message
                        if ($scope.teaserPanel.css === 'info') {
                            angular.merge($scope.teaserPanel, { css: null, body: null });
                        }

                        if ($scope.breadcrumb.length > 2) {
                            $scope.breadcrumb.pop();
                        }
                        var sMyFees = $filter('translate')('account.myMembership');
                        $scope.breadcrumb.push({ label: sMyFees, state: 'member.membership.list' });
                        $rootScope.title = $filter('translate')('account.title') + ' - ' + sMyFees.toLowerCase();
                        $rootScope.titlePanel = sMyFees;
                    }],
                    template: '<div ui-view="subcontent"></div>'
                }
            }
        })
        .state('member.membership.list', {
            url: '/' + urls.member.membership.list.fr, // TODO : when multilang, change this to something dynamic
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                subcontent: {
                    controller: ['$scope', '$rootScope', 'drupal', 'profile', 'tools', '$q', 'moment', 'lodash', function ($scope, $rootScope, drupal, profile, tools, $q, moment, lodash) {
                        $scope.loading = true;

                        // retrieve membership fees
                        drupal.getMembershipOrders(profile.info.field_sfid).then(function (fees) {
                            fees.map(function (fee){
                                if (fee.page  && fee.page.field_main_visual && fee.page.field_main_visual.length > 0){
                                    fee.main_visual_random = lodash.sample(fee.page.field_main_visual);
                                }
                            });
                            $scope.fees = fees
                                // remove licences
                                .filter(tools.filterMembership)
                                .sort(function (a, b) {
                                    return a.name.localeCompare(b.name);
                                });

                        }).finally(function () {
                            $scope.loading = false;
                        });
                    }],
                    templateUrl: 'src/views/member/member_membership.html'
                }
            }
        });
}]);
